// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Image_wrap__18W7_","img":"Image_img__3afCr","image":"Image_image__pVLQQ"};